module.exports = __webpack_public_path__ + "img/languageTwoActive.bb846be8.png";